module.exports = __webpack_public_path__ + "img/footer-1-3.a6e6c6e7.png";